/*
READY
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	
}); 

/*
LOAD
*/

jQuery(window).on("load", function() {


	/*
	Display Chatbox
	*/
	var body = jQuery("body"),
		chatbox = jQuery(".chatbox");
		fixedredbox = jQuery(".fixedredboxes");
	if(body.hasClass('home')) {
		jQuery(window).on("scroll", function() {
			var window_height_2 = jQuery(window).height()/2;
			var scroll = jQuery(window).scrollTop();
			if (scroll >= window_height_2) {
				chatbox.addClass('roll_in');
				fixedredbox.addClass('fade_in');
				jQuery(window).off('scroll');
			}
		});
		
	} else {
		chatbox.addClass('fade_in');
		jQuery(window).on("scroll", function() {
			var window_height_2 = jQuery(window).height()/2;
			var scroll = jQuery(window).scrollTop();
			if (scroll >= window_height_2) {
				fixedredbox.addClass('fade_in');
			}
		});
	}

});